import { RiskLevel } from "@/model/RiskLevel";
import Logo from "@/assets/regions/NVB_logo.png";
const Default = {
    rawCopy: "For alcohol advice and support in the Bradford District, <strong>call New Directions on 01274&nbsp;296023</strong> " +
        "or email info@newvisionbradford.org.uk",
    logoLink: "https://www.newvisionbradford.org.uk"
};
const BradfordIncreasing = {
    rawCopy: `For Increasing Risk scores we recommend that you cut down your drinking. Click here to <u>book a free online appointment</u> with DrinkCoach.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/32"
};
const BradfordHigher = {
    rawCopy: `For Higher Risk scores we recommend that you cut down your drinking. Click here to <u>book a free online appointment</u> with DrinkCoach.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/32"
};
export default {
    name: "Bradford District",
    zoomLevel: 10,
    logo: {
        file: Logo,
        width: 430,
        height: 260
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: Default,
        [RiskLevel.Lower]: Default,
        [RiskLevel.Increasing]: BradfordIncreasing,
        [RiskLevel.Higher]: BradfordHigher,
        [RiskLevel.High]: Default
    },
    regions: [
        "Bradford East",
        "Bradford South",
        "Bradford West",
        "Keighley",
        "Shipley"
    ],
    clinics: [
        {
            name: "New Directions",
            other_info: "New Directions has several hubs - use the 'Find Support Near You' tool to find your closest one:",
            description: "Contact New Directions on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            phone: ["01274 296023"],
            isPrimaryProvider: true,
            linkToSupportFinderInAddress: true,
            address: "Unity House, 30 Manningham Lane, Bradford BD1 3ND",
            times: [
                {
                    title: "Opening times:",
                    info: "<br>Mon to Fri: 9.15am – 5.15pm<br>" +
                        "Open later on Tuesdays and Thursdays",
                }
            ],
            email: "info@newvisionbradford.org.uk",
            website: "https://www.newvisionbradford.org.uk"
        },
        {
            name: "New Directions",
            description: "Contact ${name} on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            location: { lat: 53.7990129, lng: -1.7599949 },
            phone: ["01274 296023"],
            address: "Unity House, 30 Manningham Lane, Bradford BD1 3ND",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 915, end: 1715 }],
                        tuesday: [{ start: 915, end: 2000 }],
                        wednesday: [{ start: 915, end: 1715 }],
                        thursday: [{ start: 915, end: 2100 }],
                        friday: [{ start: 915, end: 1715 }]
                    }
                }
            ],
            email: "info@newvisionbradford.org.uk",
            website: "https://www.newvisionbradford.org.uk"
        },
        {
            name: "New Directions",
            location: { lat: 53.7950079, lng: -1.7487272 },
            phone: ["01274 296023"],
            address: "Pelican House, 10 Currer Street, Bradford BD1 5BA",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 915, end: 1715 }],
                        tuesday: [{ start: 915, end: 2000 }],
                        wednesday: [{ start: 915, end: 1715 }],
                        thursday: [{ start: 915, end: 1715 }],
                        friday: [{ start: 915, end: 1715 }]
                    }
                }
            ],
            email: "info@newvisionbradford.org.uk",
            website: "https://www.newvisionbradford.org.uk"
        },
        {
            name: "New Directions",
            location: { lat: 53.8662686, lng: -1.9125836 },
            phone: ["01274 296023"],
            address: "18 Temple Street, Keighley BD21 2AD",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 915, end: 1715 }],
                        tuesday: [{ start: 915, end: 1715 }],
                        wednesday: [{ start: 915, end: 1715 }],
                        thursday: [{ start: 915, end: 1715 }],
                        friday: [{ start: 915, end: 1715 }]
                    }
                }
            ],
            email: "info@newvisionbradford.org.uk",
            website: "https://www.newvisionbradford.org.uk"
        },
        {
            name: "New Directions",
            location: { lat: 53.866336, lng: -1.9128117 },
            phone: ["01274 296023"],
            address: "23 Temple Street, Keighley BD21 2AD",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 915, end: 1715 }],
                        tuesday: [{ start: 915, end: 1715 }],
                        wednesday: [{ start: 915, end: 1715 }],
                        thursday: [{ start: 915, end: 1715 }],
                        friday: [{ start: 915, end: 1715 }]
                    }
                }
            ],
            email: "info@newvisionbradford.org.uk",
            website: "https://www.newvisionbradford.org.uk"
        },
        {
            name: "New Directions",
            tagline: "(Harm Reduction and Needle Exchange only)",
            location: { lat: 53.865954, lng: -1.9126934 },
            phone: ["01274 296023"],
            address: "6 Temple Street, Keighley, BD21 2AD",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 915, end: 1715 }],
                        tuesday: [{ start: 915, end: 1715 }],
                        wednesday: [{ start: 915, end: 1715 }],
                        thursday: [{ start: 915, end: 1715 }],
                        friday: [{ start: 915, end: 1715 }]
                    }
                }
            ],
            email: "info@newvisionbradford.org.uk",
            website: "https://www.newvisionbradford.org.uk"
        }
    ]
};
//# sourceMappingURL=Bradford.js.map